import { environment } from '../../environments/environment';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  {
    name: 'switch_inline',
    src: environment.production
      ? 'https://newwebpay.interswitchng.com/inline-checkout.js'
      : // : 'https://newwebpay.qa.interswitchng.com/inline-checkout.js',
        'https://newwebpay-sandbox.interswitchng.com/inline-checkout.js',
  },
];
